import { Injectable, TemplateRef } from '@angular/core';

import { Subject } from 'rxjs';

import { CustomDialogWithActionsComponent } from '../config';
import { DialogResult } from '../models/dialog.result';

@Injectable()
export class DialogBehaviorService {
  readonly tertiaryButtonClick = new Subject<void>();
  readonly additionalButtonClick = new Subject<void>();
  readonly onConfirmClicked = new Subject<void>();
  readonly onConfirmEnabledChange = new Subject<boolean>();
  readonly onConfirmInProgress = new Subject<boolean>();
  readonly onCancelEnabledChange = new Subject<boolean>();
  readonly onAdditionalButtonEnabledChange = new Subject<boolean>();
  readonly onTertiaryButtonEnabledChange = new Subject<boolean>();
  readonly onAdditionalActionsTemplateChange = new Subject<TemplateRef<any>>();
  readonly onAdditionalButtonVisibilityChange = new Subject<boolean>();
  readonly onTertiaryButtonVisibilityChange = new Subject<boolean>();
  readonly onAdditionalButtonInProgress = new Subject<boolean>();
  readonly onTertiaryButtonInProgress = new Subject<boolean>();
  readonly closeDialog = new Subject<any>();
  readonly dialogResult = new Subject<DialogResult>();

  constructor() {}

  setupCustomComponentActions(
    component: CustomDialogWithActionsComponent
  ): void {
    component.onCloseDialog = this.closeDialog;
    component.onConfirmEnabledChange = this.onConfirmEnabledChange;
    component.onCancelEnabledChange = this.onCancelEnabledChange;
    component.onAdditionalButtonVisibilityChange =
      this.onAdditionalButtonVisibilityChange;
    component.onConfirmClicked = this.onConfirmClicked;
    component.onAdditionalButtonClicked = this.additionalButtonClick;
    component.onAdditionalButtonEnabledChange =
      this.onAdditionalButtonEnabledChange;
    component.onTertiaryButtonClicked = this.tertiaryButtonClick;
    component.onTertiaryButtonVisibilityChange =
      this.onTertiaryButtonVisibilityChange;
    component.onTertiaryButtonEnabledChange =
      this.onTertiaryButtonEnabledChange;
    component.onConfirmInProgress = this.onConfirmInProgress;
    component.onAdditionalButtonInProgress = this.onAdditionalButtonInProgress;
    component.onTertiaryButtonInProgress = this.onTertiaryButtonInProgress;
    component.dialogResult = this.dialogResult;
    component.onAdditionalActionsTemplateChange =
      this.onAdditionalActionsTemplateChange;
  }
}
